import { AnyString } from '../../../utils/types';
import { TimerWeekday } from '../helpers/TimerHelper';
import { ShortWeekdayType, WeekdayNamed, WeekdayNumbered, WeekdayNumberType, WeekdayType } from './IPower';

export type BackwardsCompatibleWeekdayType = WeekdayType | ShortWeekdayType | WeekdayNumberType | AnyString;

export const SHORT_WEEKDAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'] as const;

export function convertWeekdayToNumber(weekday: WeekdayType): WeekdayNumberType {
	return WeekdayNumbered[weekday as keyof typeof WeekdayNumbered];
}

export function convertBCWeekdayToNumber(weekday: BackwardsCompatibleWeekdayType): WeekdayNumberType {
	const short = coalesceWeekdayType(weekday);

	return TimerWeekday[short];
}

export function convertNumberToWeekday(weekday: number) {
	return WeekdayNumbered[weekday] as keyof typeof WeekdayNumbered;
}

export const coalesceWeekdayType = (weekday: BackwardsCompatibleWeekdayType): ShortWeekdayType => {
	if (isShortWeekdayType(weekday)) {
		return weekday;
	}

	if (isWeekdayType(weekday)) {
		return (
			{
				MONDAY: 'mon',
				TUESDAY: 'tue',
				WEDNESDAY: 'wed',
				THURSDAY: 'thu',
				FRIDAY: 'fri',
				SATURDAY: 'sat',
				SUNDAY: 'sun',
			} as const
		)[weekday];
	}

	if (isWeekdayNumberType(weekday)) {
		return SHORT_WEEKDAYS[weekday];
	}

	throw new Error(`Unknown week day value "${weekday}"`);
};

const isShortWeekdayType = (weekday: BackwardsCompatibleWeekdayType): weekday is ShortWeekdayType =>
	(SHORT_WEEKDAYS as readonly unknown[]).includes(weekday);

const isWeekdayType = (weekday: BackwardsCompatibleWeekdayType): weekday is WeekdayType => weekday in WeekdayNamed;

const isWeekdayNumberType = (weekday: BackwardsCompatibleWeekdayType): weekday is WeekdayNumberType =>
	typeof weekday === 'number' && weekday >= 0 && weekday <= 6;
